const heading = "_j0jhghkcnu";

export { heading };
import "./heading.style.linaria.module.css";
//# sourceMappingURL=heading.style.js.map
